import { useZoom, ZoomMode } from "@embedpdf/plugin-zoom/react";
import { UndoIcon, ZoomInIcon, ZoomOutIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox.tsx";
import { VnButton } from "@/components/VnButton/VnButton.tsx";
import { VnIcon } from "@/components/VnIcon.tsx";
import { VnText } from "@/components/VnText/VnText.tsx";

export type VnPdfToolbarPropsType = {
  documentId: string;
};

export const VnPdfToolbar = ({ documentId }: VnPdfToolbarPropsType) => {
  const { provides: zoomProvides, state: zoomState } = useZoom(documentId);

  if (!zoomProvides) {
    return null;
  }

  return (
    <VnBox className="bg-background border-sidebar-border flex flex-row items-center gap-2 border-b px-4 py-2">
      <VnText i18nKey="common:zoom" />
      <VnButton
        onPress={() => {
          zoomProvides.zoomOut();
        }}
        variant="outline">
        <VnIcon as={ZoomOutIcon} />
      </VnButton>
      <VnText>{Math.round(zoomState.currentZoomLevel * 100)}%</VnText>
      <VnButton
        onPress={() => {
          zoomProvides.zoomIn();
        }}
        variant="outline">
        <VnIcon as={ZoomInIcon} />
      </VnButton>
      <VnButton
        onPress={() => {
          zoomProvides.requestZoom(ZoomMode.FitWidth);
        }}
        variant="outline">
        <VnIcon as={UndoIcon} />
      </VnButton>
    </VnBox>
  );
};
